// extracted by mini-css-extract-plugin
export default {"container_list":"Paginado_container_list__Bk5Rd","numbers":"Paginado_numbers__gdiEz","buttonPage":"Paginado_buttonPage__JMcbn","buttonPage2":"Paginado_buttonPage2__YtGAb"};